import { render, staticRenderFns } from "./TotalIndex.vue?vue&type=template&id=75c97962&scoped=true&"
import script from "./TotalIndex.vue?vue&type=script&lang=js&"
export * from "./TotalIndex.vue?vue&type=script&lang=js&"
import style0 from "./TotalIndex.vue?vue&type=style&index=0&id=75c97962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c97962",
  null
  
)

export default component.exports